import {MODE_CREATE} from "../../../codes";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import useProject from "../../../util/useProject";
import {FabButton} from "../../../common/FabButton";
import {listConfigSelector, rxShowMileageLogEditor} from "../../../slices/mileageLogsSlice";
import {selectAllCars} from "../../../slices/carsSlice";

export const LoansFab = () => {
  const dispatch = useDispatch();

  const {runWithExpiration} = useProject();

  const {selectedCarId} = useSelector(listConfigSelector);

  const selectedCar = useSelector(selectAllCars).find(c => c.id === selectedCarId);

  const showMileageLogEditor = (mode, mileageLog) => dispatch(rxShowMileageLogEditor({mode, mileageLog}));

  if (!selectedCar) {
    return null;
  }

  return <FabButton onClick={runWithExpiration(() => showMileageLogEditor(MODE_CREATE, {}))}/>;
};
